import { useEffect, useState } from 'react';
import {
  AppBar,
  Box,
  Container,
  Toolbar,
  Select,
  MenuItem,
  FormControl,
  useMediaQuery,
  SelectChangeEvent,
} from '@mui/material';
import Logo from '@/assets/logo.svg';
import LanguageIcon from '@mui/icons-material/Language';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { theme } from '@/styles/theme';

export const SimpleHeader = () => {
  const { t, i18n } = useTranslation('logout');
  const navigate = useNavigate();

  const [language, setLanguage] = useState(() =>
    i18n.language ? i18n.language.substring(0, 2) : 'pt'
  );

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));


  const handleChangeLanguage = (event: SelectChangeEvent) => {
    const newLanguage = event.target.value;
    setLanguage(newLanguage);
    i18n.changeLanguage(newLanguage);
  };

  useEffect(() => {
    if (i18n.language) {
      setLanguage(i18n.language.substring(0, 2));
    }
  }, [i18n.language]);

  return (
    <>
      <AppBar
        position="static"
        color="default"
        elevation={0}
        sx={styles.appBar}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters sx={styles.toolbar}>
            <Box sx={styles.logoBox}>
              <Box
                sx={styles.logo}
                component="img"
                src={Logo}
                onClick={() => navigate('/')}
              />
            </Box>

            <Box sx={styles.rightSection}>
              <Box sx={styles.languageSelector}>
                {!isSmallScreen && <LanguageIcon sx={{ fontSize: '2rem' }} />}
                <FormControl variant="standard" sx={styles.selectControl}>
                  <Select
                    value={language}
                    onChange={handleChangeLanguage}
                    disableUnderline
                    sx={styles.select}
                  >
                    <MenuItem value="en">
                      {isSmallScreen ? t('short_en') : t('lang_en')}
                    </MenuItem>
                    <MenuItem value="es">
                      {isSmallScreen ? t('short_es') : t('lang_es')}
                    </MenuItem>
                    <MenuItem value="pt">
                      {isSmallScreen ? t('short_pt') : t('lang_pt')}
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

    </>
  );
};

const styles = {
  appBar: {
    backgroundColor: '#ffffff',
    width: '100%',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
    },
  },
  logoBox: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    maxHeight: 30,
  },
  logo: {
    cursor: 'pointer',
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
  languageSelector: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    [theme.breakpoints.down('sm')]: {
      marginLeft: -1,
    },
  },
  selectControl: {
    minWidth: 100,
    [theme.breakpoints.down('sm')]: {
      minWidth: 0,
      marginLeft: -1,
      marginRight: -2,
    },
  },
  select: {
    fontSize: '1.4rem',
  },
  logoutIcon: {
    fontSize: '2.5rem',
  },
};
